import { useEstablishmentLocationChartsDataContext } from './hooks/useEstablishmentLocationChartsDataContext';
import { CihaSpotsMap } from '../../Common/Charts/CihaSpotsMap';

const SPOTS_CONFIG = {
    popupFields: {
        title: "nome",
        showLocal: false,

        details: {
            codigo: "codigo",
            total: "total",
            percentual: "pct",
        },
    },

    filters: [
        {
            key: "nome",
            label: "Filtrar por Município",
            type: "select",
        },
    ],

    marker: {
        weight: 26,
        color: "#0D82D3",
    },

    stats: [],
};

export function TopMunicipalitiesMap() {
    const { chartData } =
        useEstablishmentLocationChartsDataContext();

    const spots = (chartData?.topMunicipalities || [])
        .filter(
            (item) =>
                item.city_latitude != null &&
                item.city_longitude != null &&
                item.nome
        )
        .map((item) => ({
            ...item,
            latitude: Number(item.city_latitude),
            longitude: Number(item.city_longitude),
        }));

    return (
        <CihaSpotsMap
            spots={spots}
            config={SPOTS_CONFIG}
        />
    );
}